import React from 'react';
import classNames from 'classnames';

import styles from './ChipListHeader.module.scss';

export interface ChipListHeaderProps {
  searchMode?: boolean;
  showDateOwner?: boolean;
}

export default function ChipListHeader({ searchMode = false, showDateOwner = true }: ChipListHeaderProps) {
  return (
    <div
      className={classNames(styles.main, {
        [styles.searchMode]: searchMode,
        [styles.hideDateOwner]: !showDateOwner,
      })}
    >
      <div>Name</div>
      <div>Chip ID</div>
      <div>Breed</div>
      {showDateOwner && <div>Date registered</div>}
      {showDateOwner && <div>Owner</div>}
      {searchMode && <div>Status</div>}
    </div>
  );
}
